// Code generated by @sumup/sumup-ts-codegen. DO NOT EDIT.

import {
  APIResource,
  type RequestOptions,
  type WithResponse,
} from "../../core";
import type { ErrorExtended, FinancialPayouts } from "../../types";
export type ListPayoutsV1QueryParams = {
  start_date: string;
  end_date: string;
  format?: "json" | "csv";
  limit?: number;
  order?: "asc" | "desc";
};

export type ListPayoutsV1Error = ErrorExtended[];

/**
 * API resource for the Payouts endpoints.
 *
 * The Payouts model will allow you to track funds you’ve received from SumUp.
 *
 * You can receive a detailed payouts list with information like dates, fees, references and statuses, using the `List payouts` endpoint.
 */
export class Payouts extends APIResource {
  /**
   * Lists payout and payout-deduction records for the specified merchant account within the requested date range.
   *
   * The response can include:
   * - regular payouts (`type = PAYOUT`)
   * - deduction records for refunds, chargebacks, direct debit returns, or balance adjustments
   *
   * Results are sorted by payout date in the requested `order`.
   */
  list(
    merchantCode: string,
    query: ListPayoutsV1QueryParams,
    options?: RequestOptions,
  ): Promise<FinancialPayouts> {
    return this._client.get<FinancialPayouts>({
      path: `/v1.0/merchants/${merchantCode}/payouts`,
      query,
      ...options,
    });
  }

  listWithResponse(
    merchantCode: string,
    query: ListPayoutsV1QueryParams,
    options?: RequestOptions,
  ): Promise<WithResponse<FinancialPayouts>> {
    return this._client.getWithResponse<FinancialPayouts>({
      path: `/v1.0/merchants/${merchantCode}/payouts`,
      query,
      ...options,
    });
  }
}
